import React from "react";
import { useParams } from "react-router";
import { getCalendarDay } from "../../calendar/utils";
import { Canticle } from "../../chants/Canticle";
import { TweakProvider } from "../../utils/TweakProvider";
import { Spacer } from "../pray/Spacer";

export const CanticlePage: React.FC<{}> = () => {
    const { id, tone } = useParams<{ id: string; tone: string }>();

    const canticleId: any = id.replace(/-/g, " ");

    const dateTime = new Date();
    if (dateTime.getHours() < 3) {
        dateTime.setDate(dateTime.getDate() - 1);
    }

    const date = dateTime.getDate();
    const month = dateTime.getMonth() + 1;
    const year = dateTime.getFullYear();

    const day = getCalendarDay(year, month, date, true);

    return (
        <>
            <TweakProvider initialState={{}}>
                <div style={{ paddingTop: 32, paddingBottom: 32 }}>
                    <Canticle
                        id={canticleId}
                        day={day}
                        tone={tone === "tpa" ? "Tonus Peregrinus A" : tone}
                    />
                </div>
            </TweakProvider>
            <Spacer />
        </>
    );
};
